import {
  Atom,
  Box,
  Boxes,
  Brain,
  Briefcase,
  Bug,
  Code,
  Cog,
  Compass,
  Cpu,
  Crown,
  Database,
  FileCode,
  Flame,
  Folder,
  Gem,
  GitBranch,
  Globe,
  Hammer,
  Heart,
  Hexagon,
  Layers,
  Lightbulb,
  Lock,
  Mail,
  MessageSquare,
  Package,
  Puzzle,
  Radar,
  Rocket,
  Search,
  Shield,
  Sparkles,
  Star,
  Target,
  Telescope,
  Terminal,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";
import { PROJECT_ICON_NAMES, type ProjectIconName } from "@paperclipai/shared";

export const PROJECT_ICONS: Record<ProjectIconName, LucideIcon> = {
  folder: Folder,
  rocket: Rocket,
  code: Code,
  terminal: Terminal,
  database: Database,
  globe: Globe,
  package: Package,
  boxes: Boxes,
  box: Box,
  layers: Layers,
  briefcase: Briefcase,
  compass: Compass,
  target: Target,
  flame: Flame,
  zap: Zap,
  star: Star,
  bug: Bug,
  wrench: Wrench,
  hammer: Hammer,
  lightbulb: Lightbulb,
  sparkles: Sparkles,
  shield: Shield,
  lock: Lock,
  search: Search,
  cog: Cog,
  brain: Brain,
  cpu: Cpu,
  "git-branch": GitBranch,
  "file-code": FileCode,
  puzzle: Puzzle,
  gem: Gem,
  atom: Atom,
  heart: Heart,
  mail: Mail,
  "message-square": MessageSquare,
  crown: Crown,
  radar: Radar,
  telescope: Telescope,
  hexagon: Hexagon,
};

const DEFAULT_ICON: ProjectIconName = "folder";

export function getProjectIcon(iconName: string | null | undefined): LucideIcon {
  if (iconName && PROJECT_ICON_NAMES.includes(iconName as ProjectIconName)) {
    return PROJECT_ICONS[iconName as ProjectIconName];
  }
  return PROJECT_ICONS[DEFAULT_ICON];
}
